@use "../../sass/variables/colors";
@use "../../sass/variables/grid";
@use "../../sass/variables/typography";
@use "../../sass/mixins/font-family";

:host([variant="default"]) {
    @include font-family.font(light);
    display: block;
    font-size: var(--ux-text-font-size-normal);
    line-height: var(--ux-text-line-height-normal);
    margin-block-start: 1em;
    margin-block-end: 1em;

    @media (min-width: grid.$bp-xl) {
        font-size: typography.$size-text-normal;
        line-height: typography.$line-height-normal;
    }
}

:host([variant="title"]) {
    @include font-family.font(regular);
    font-size: typography.$size-title-normal;
}

:host([variant="teaser"]) {
    @include font-family.font(bold);

    color: colors.$color-black;
    font-size: typography.$size-text-normal;
    line-height: 26px;

    @media only screen and (width >=1024px) {
        font-size: typography.$size-text-normal-plus;
    }
}


:host([strong]) {
    @include font-family.font(bold);
    color: colors.$color-gray-copy;
}

:host([light]) {
    @include font-family.font(light);
}

:host([big]) {
    font-size: typography.$size-title-regular;
}

:host([variant='tiny']) {
    font-size: typography.$size-text-small;
    line-height: 1.6;
}